import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SectionHeader = ({
  title,
  subtitle,
  align,
  spacing,
  actions,
}) => {
  if (!title && !subtitle && !actions) {
    return null;
  }

  const hasActions = !!actions;

  return (
    <header
      className={classnames('puck-section-header', {
        'puck-section-header-spacing': spacing,
        'puck-section-header-with-actions': hasActions,
        'puck-section-header-align-center': hasActions && align === 'center',
      })}
    >
      <div className="puck-section-header-main">
        {title && (
          <h1 className={classnames('puck-section-title page-font-primary', {
            'puck-section-title-left': align === 'left',
            'puck-section-title-center': align === 'center',
            'puck-section-title-right': align === 'right',
          })}
          >
            {title}
          </h1>
        )}
        {subtitle && (
          <h2 className={classnames('puck-section-subtitle page-font-secondary', {
            'puck-section-subtitle-left': align === 'left',
            'puck-section-subtitle-center': align === 'center',
            'puck-section-subtitle-right': align === 'right',
          })}
          >
            {subtitle}
          </h2>
        )}
      </div>
      {hasActions && <div className="puck-section-header-actions">{actions}</div>}
    </header>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  spacing: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  actions: PropTypes.node,
};

SectionHeader.defaultProps = {
  spacing: false,
  title: '',
  subtitle: '',
  align: 'left',
  actions: null,
};

export default SectionHeader;
